import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useWa } from "@/lib/content";
import { useContent, rich } from "@/lib/content";
import { Reveal, SectionTitle, WhatsIcon } from "./Primitives";

const Row = ({ m, open, onToggle }) => (
  <div className="border-b border-gold/15">
    <button data-testid={`reuniones-${m.key}-card`} onClick={onToggle} className="group grid w-full grid-cols-[1fr_auto] items-center gap-4 py-7 text-left md:grid-cols-[120px_1fr_auto] md:gap-8">
      <div className="hidden h-20 w-28 overflow-hidden rounded-xl md:block">
        <img src={m.img} alt={m.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
      </div>
      <div>
        <h3 className="font-display text-3xl text-cream transition-colors group-hover:text-gold md:text-5xl">{m.name}</h3>
        <p className="mt-1 font-display text-lg italic text-sand">{m.de}</p>
      </div>
      <motion.span animate={{ rotate: open ? 45 : 0 }} className="rounded-full border border-gold/30 p-3 text-gold">
        <Plus size={18} />
      </motion.span>
    </button>
    <motion.div initial={false} animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }} className="overflow-hidden">
      <div className="grid gap-8 pb-10 md:grid-cols-[1fr_1.4fr]">
        <img src={m.img} alt={m.name} loading="lazy" className="aspect-[4/3] w-full rounded-2xl object-cover" />
        {(m.items || []).length ? (
          <ul className="columns-1 gap-8 sm:columns-2">
            {m.items.map((it) => (
              <li key={it} className="mb-3 break-inside-avoid border-b border-gold/10 pb-3 font-sans text-sand">{it}</li>
            ))}
          </ul>
        ) : (
          <p className="font-sans text-lg text-sand">Pregunta por nuestros paquetes para tu empresa, reunión o evento familiar.</p>
        )}
      </div>
    </motion.div>
  </div>
);

export const Reuniones = () => {
  const [open, setOpen] = useState(null);
  const { MEETINGS, TEXTS: T } = useContent();
  const waLink = useWa();
  return (
    <section id="reuniones" data-testid="reuniones-section" className="bg-roast py-20 md:py-28 lg:py-40">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionTitle eyebrow={T.reu_eyebrow} title={rich(T.reu_title)} testid="reuniones-title" />
          <Reveal className="mt-10">
            <a
              data-testid="reuniones-quote-whatsapp-btn"
              href={waLink("wa_msg_reu")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 font-sans text-sm font-semibold text-espresso transition-colors hover:bg-gold-light"
            >
              <WhatsIcon className="h-4 w-4" /> {T.btn_reu_wa}
            </a>
          </Reveal>
        </div>
        <Reveal className="border-t border-gold/15 lg:col-span-8">
          {MEETINGS.map((m) => (
            <Row key={m.key} m={m} open={open === m.key} onToggle={() => setOpen(open === m.key ? null : m.key)} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};
